// Homepage content data. Placeholder figures/quotes — replace with real
// marketing-approved numbers, client list, and testimonials when available.

// Verbatim from the live site (tablespace.com) — auditor-approved IPO figures.
export const heroStats = [
  { value: "8", label: "Cities" },
  { value: "9.9+", label: "Mn Sq Ft" },
  { value: "315+", label: "Global Enterprise Clients" },
];

// Solution pills under the hero search bar — order matches the design.
export const heroPills = [
  { slug: "custom-built", label: "Custom Built" },
  { slug: "suites", label: "Suites" },
  { slug: "desyn", label: "DESYN" },
  { slug: "global-connect", label: "Global Connect" },
  { slug: "enterprise-services", label: "Enterprise Services" },
];

// All eight cities for the Locations grid (placeholder counts + images).
export const featuredCities = [
  { slug: "bengaluru", name: "Bengaluru", locations: 29, clients: 90, image: "/images/city-bengaluru.jpg" },
  { slug: "hyderabad", name: "Hyderabad", locations: 8, clients: 40, image: "/images/city-hyderabad.jpg" },
  { slug: "mumbai", name: "Mumbai", locations: 10, clients: 55, image: "/images/city-mumbai.jpg" },
  { slug: "gurugram", name: "Gurugram", locations: 10, clients: 35, image: "/images/city-gurugram.jpg" },
  { slug: "noida", name: "Noida", locations: 2, clients: 25, image: "/images/city-noida.jpg" },
  { slug: "delhi", name: "New Delhi", locations: 1, clients: 20, image: "/images/city-delhi.jpg" },
  { slug: "chennai", name: "Chennai", locations: 5, clients: 18, image: "/images/city-chennai.jpg" },
  { slug: "pune", name: "Pune", locations: 13, clients: 15, image: "/images/city-pune.jpg" },
];

// "Why choose Table Space" — the five benefits, VERBATIM from the live site
// (tablespace.com) so the copy matches the auditor-approved IPO content.
export const whyChoose = [
  {
    title: "Built-in Efficiency",
    body: "Understanding the importance of time in a fast-paced business world, Table Space offers an integrated single-cheque solution and delivers your office as early as 90 days while ensuring world-class quality and functionality for businesses, enabling your businesses to focus on growth.",
  },
  {
    title: "Industry-Leading Expertise",
    body: "Backed by years of cumulative experience in real estate, our leadership team understands enterprise needs at scale. With a portfolio of 315+ unique clients across GCCs, MNCs, and leading enterprises and over 9.9+ million square feet of managed workspace, we blend deep industry knowledge with a client-focused approach to deliver outstanding results.",
  },
  {
    title: "Unparalleled Flexibility",
    body: "From Ready-To-Move-in Suites to fully customized offices, Table Space offers liquid real estate solutions that evolves with business needs. With seamlessly integrated technology, get real-time space utilization updates and scale up or down as per the business needs.",
  },
  {
    title: "Complete Transparency",
    body: "Our Enterprise Workspace-as-a-Service (WaaS) capitalizes on advanced technology to meticulously build state-of-the-art workspaces. We provide detailed commercial proposals that offer clear insights into every aspect of your workspace requirements. With real-time reporting on build out progress and ongoing operations, get complete visibility and control at every stage.",
  },
  {
    title: "Continuous Transformation",
    body: "We deliver high-performance workspaces built on secure, compliant and sustainable foundations, powered by cutting-edge technology. Designed to global standards, our environments evolve with your business, driving productivity, enabling collaboration, and ensuring long-term continuity.",
  },
];

// Real Table Space clients with their OFFICIAL logos (sourced from
// tablespace.com's own client wall) in /public/images/clients/*.webp.
export type Client = { name: string; logo?: string };
export const clients: Client[] = [
  { name: "Fujitsu", logo: "/images/clients/fujitsu.webp" },
  { name: "Mastercard", logo: "/images/clients/mastercard.webp" },
  { name: "Siemens", logo: "/images/clients/siemens.webp" },
  { name: "Shell", logo: "/images/clients/shell.webp" },
  { name: "American Express", logo: "/images/clients/american-express.webp" },
  { name: "Ericsson", logo: "/images/clients/ericsson.webp" },
  { name: "eBay", logo: "/images/clients/ebay.webp" },
  { name: "AMD", logo: "/images/clients/amd.webp" },
  { name: "Emerson", logo: "/images/clients/emerson.webp" },
  { name: "PACCAR", logo: "/images/clients/paccar.webp" },
  { name: "Medtronic", logo: "/images/clients/medtronic.webp" },
  { name: "Colgate", logo: "/images/clients/colgate.webp" },
  { name: "McKesson", logo: "/images/clients/mckesson.webp" },
  { name: "Salesforce", logo: "/images/clients/salesforce.webp" },
  { name: "Stantec", logo: "/images/clients/stantec.webp" },
  { name: "Houlihan Lokey", logo: "/images/clients/houlihan-lokey.webp" },
  { name: "ZS Associates", logo: "/images/clients/zs-associates.webp" },
  { name: "FirstRand", logo: "/images/clients/firstrand.webp" },
];

export const testimonial = {
  quote:
    "Dependable, affable, and fair, your team delivered a responsive and genuine service that perfectly understood our needs and helped us get to ground fast.",
  company: "PACCAR",
  author: "Vinit Kapur",
  title: "Director Of Information Technology",
};

// Single-quote testimonial stage (placeholder quotes — replace with approved
// client statements before launch). Each maps to a portrait in /public/images.
// FAQ — rendered visibly (Accordion) AND emitted as FAQPage JSON-LD. Answers
// are written to be self-contained so AI assistants can quote them cleanly.
export const faqs = [
  {
    title: "What is Table Space?",
    body: "Table Space is one of India's leading enterprise managed-office (Workspace-as-a-Service) providers. We lease, design, build and operate Grade A offices for global enterprises, GCCs and large corporations — managing 11.46 million sq ft of workspace across 9 Indian cities for 425+ enterprise clients.",
  },
  {
    title: "Which cities do you operate in?",
    body: "Eight: Bengaluru, Hyderabad, Mumbai, Gurugram, Noida, Delhi, Chennai and Pune — the country's primary GCC and enterprise corridors.",
  },
  {
    title: "What solutions do you offer?",
    body: "Five: Custom Built (bespoke managed offices in about 90 days), move-in-ready Suites, DESYN (integrated design and build), Global Connect (India GCC setup and scaling) and Enterprise Services (workplace operations run as a service).",
  },
  {
    title: "How quickly can you deliver an office?",
    body: "Custom-built offices are typically ready in as little as 90 days under a single, simple agreement; move-in-ready suites can be available in days.",
  },
  {
    title: "Who is Table Space for?",
    body: "Table Space is built for large enterprises, Fortune 500 companies, multinationals and Global Capability Centres (GCCs) that need scalable, compliant, Grade A managed workspaces without upfront capital investment.",
  },
];

// VERBATIM client testimonials from the live site (tablespace.com) — real
// clients and quotes, matching the auditor-approved IPO content.
export const testimonials = [
  {
    quote:
      "Dependable, affable, and fair, your team delivered a responsive and genuine service that perfectly understood our needs and helped us get to ground fast.",
    name: "Vinit Kapoor",
    detail: "Director of Information Technology · PACCAR",
    image: "/images/home/paccar.webp",
  },
  {
    quote:
      "We chose Table Space for its flexible, scalable office solutions that matched our evolving needs. Their modern workspaces and agile model enabled us to expand quickly in Gurugram without the delays of traditional office setups.",
    name: "Wood Mackenzie",
    detail: "Table Space DLF Cyber Greens, 8th Floor · Gurugram",
    image: "/images/home/wood-mackenzie.webp",
  },
  {
    quote:
      "As we planned our expansion, we needed more than just office space—we needed a workspace partner that could grow with us. Table Space Suites has been instrumental in supporting our growth journey.",
    name: "Bulerez",
    detail: "Table Space MFAR-2B, Manyata Tech Park · Bangalore",
    image: "/images/home/bulerez.webp",
  },
];
